import React from 'react';
import { useTranslate } from '@tolgee/react';
import { TrackingTab } from '../orderTracking.interface';
import { TRACKING_TABS } from '../orderTracking.constants';
import { cn } from '../../../../lib/utils';
import SimpleFile from '../../../../assets/SimpleFile';
import FolderIcon from '../../../../assets/FolderIcon';

interface TrackingTabsProps {
	value: TrackingTab;
	documentsCount: number;
	onChange: (tab: TrackingTab) => void;
}

const TrackingTabs: React.FC<TrackingTabsProps> = ({
	value,
	documentsCount,
	onChange,
}) => {
	const { t } = useTranslate();

	return (
		<nav className="flex items-center gap-2 px-4 sm:px-7 pt-5">
			{TRACKING_TABS.map((tab) => {
				const active = tab.key === value;
				const count = tab.key === 'documents' ? documentsCount : undefined;

				return (
					<button
						key={tab.key}
						type="button"
						onClick={() => onChange(tab.key)}
						className={cn(
							'flex-1 h-10 inline-flex items-center justify-center gap-2 border border-solid box-border rounded-lg px-4 font-[inherit] text-sm cursor-pointer transition-colors duration-150',
							active
								? 'bg-track-indigo border-track-indigo text-white font-semibold'
								: 'bg-white border-track-line text-track-body font-medium hover:bg-track-hover hover:border-track-line-strong',
						)}
					>
						{tab.key === 'general' ? (
							<SimpleFile
								color={active ? '#FFFFFF' : '#484880'}
								width={18}
								height={18}
								strokeWidth="1.6"
							/>
						) : (
							<FolderIcon
								color={active ? '#FFFFFF' : '#484880'}
								width={18}
								height={18}
								strokeWidth="1.6"
							/>
						)}
						{t(tab.labelKey, tab.defaultLabel)}
						{count !== undefined ? (
							<span
								className={cn(
									'rounded-full px-2 py-[2px] text-[13px] font-semibold leading-none',
									active
										? 'bg-white/20 text-white'
										: 'bg-track-surface text-track-body',
								)}
							>
								{count}
							</span>
						) : null}
					</button>
				);
			})}
		</nav>
	);
};

export default TrackingTabs;
